import {
  Camera,
  FileStack,
  Files,
  GitCompare,
  Image as ImageIcon,
  MessageSquareText,
  Scale,
  ScrollText,
  type LucideIcon,
} from "lucide-react";
import type { ToolId } from "./readerTools";
import { READER_TOOLS } from "./readerTools";

/** Lucide icons used on the home tools grid and tool page headers. */
export const TOOL_ICONS: Record<ToolId, LucideIcon> = {
  summary: ScrollText,
  "legal-risk": Scale,
  assistant: MessageSquareText,
  compare: GitCompare,
  "word-to-pdf": FileStack,
  "pdf-split": Files,
  "pdf-merge": FileStack,
  "to-image": ImageIcon,
  "scan-document": Camera,
};

/** Dedicated illustrations when available (AI / scan). */
export const TOOL_ILLUSTRATIONS: Partial<Record<ToolId, string>> = {
  summary: "/illustrations/dadno-action-summary.png",
  "legal-risk": "/illustrations/dadno-action-risk.png",
  assistant: "/illustrations/dadno-action-consult.png",
  "scan-document": "/illustrations/scan-hero.svg",
};

/** Short header blurbs for tool pages (falls back to READER_TOOLS.blurb). */
export const TOOL_PAGE_DESCRIPTIONS: Partial<Record<ToolId, string>> = {
  compare:
    "دو نسخه را انتخاب کنید؛ تفاوت‌ها روی دستگاه محاسبه و در محیط سند نمایش داده می‌شود.",
  "pdf-split":
    "بین صفحات برش بگذارید و هر بخش را در یک فایل ZIP دانلود کنید.",
  "pdf-merge": "چند PDF را مرتب کنید و در یک فایل ادغام کنید.",
  "to-image": "صفحات را به JPG یا PNG تبدیل کنید و ذخیره یا اشتراک بگذارید.",
  "scan-document":
    "عکس بگیرید، چهار گوشه را تنظیم کنید و در پایان یک PDF تمیز و قابل اشتراک بسازید.",
  summary: "خلاصهٔ مدیریتی سند با امکان تولید مجدد و کپی/اشتراک.",
  "legal-risk": "ریسک‌های حقوقی دسته‌بندی‌شده با امکان کپی و اشتراک.",
};

/** Consumer-shell kicker labels (matches restored scan page chrome). */
export const TOOL_PAGE_KICKERS: Partial<Record<ToolId, string>> = {
  compare: "مقایسه اسناد",
  "pdf-split": "ابزار PDF",
  "pdf-merge": "ابزار PDF",
  "to-image": "خروجی تصویری",
  "scan-document": "اسکن موبایلی",
  summary: "هوش مصنوعی",
  "legal-risk": "هوش مصنوعی",
  assistant: "هوش مصنوعی",
  "word-to-pdf": "تبدیل سند",
};

export function toolPageDescription(id: ToolId): string {
  return (
    TOOL_PAGE_DESCRIPTIONS[id] ??
    READER_TOOLS.find((t) => t.id === id)?.blurb ??
    ""
  );
}

export function toolPageKicker(id: ToolId): string {
  return TOOL_PAGE_KICKERS[id] ?? "ابزار نویساین";
}
